<template>
  <div
    class="flex flex-no-wrap"
    :class="{ 'pointer-events-none': !$route.query.asset || data.readonly }"
  >
    <label
      class="mb-0 mt-1 font-semibold text-sm flex-1 whitespace-no-wrap"
      style="max-height: 29.6px"
    >
      {{ data.label }}
    </label>

    <!-- <v-select
      v-if="data.multiple && !data.readonly"
      :value="value"
      @input="$emit('input', $event)"
      :multiple="data.multiple"
      placeholder="Select"
      :label="data.label"
      style="width: 168px"
      :options="data.options"
    /> -->
    <q-select
      v-if="data.multiple && !data.readonly"
      :value="value"
      @input="$emit('input', $event)"
      use-chips
      dense
      outlined
      :filled="!$route.query.asset"
      :options="data.options"
      :multiple="data.multiple"
      class="industry w-1/2"
    />
    <span
      class="w-1/2 whitespace-no-wrap bg-white"
      v-if="data.input"
      style="height: 29.6px; padding: 0.4rem; font-size: 0.8rem"
      :style="
        $route.query.asset && !data.readonly
          ? {
              border: '1px solid rgba(0, 0, 0, 0.2)',
              borderRadius: '5px',
            }
          : {}
      "
    >
      {{ value }}
      <q-menu fit anchor="top left" self="top left" v-model="isShowing">
        <div>
          <!-- <input
            v-if="data.input"
            :value="value"
            @input="$emit('input', $event)"
            :type="data.type ? data.type : 'text'"
            size="small"
            class="w-full"
            ref="input"
            :readonly="data.readonly"
          /> -->
          <input
            @blur="isShowing = false"
            @keydown.enter="isShowing = false"
            :value="value"
            @change="$emit('input', $event.target.value)"
            :type="data.type ? data.type : 'text'"
            class="text-sm px-2 placeholder-grey z-50 w-full shadow"
            style="
              height: 30px;
              position: sticky;
              top: 0;
              background: #fcfcfc;
              border: 0;
              border-bottom: 1px solid #e1e1e1;
            "
            ref="input"
          />
        </div>
      </q-menu>
    </span>
    <!-- <vs-input
      v-if="data.input"
      :value="value"
      @input="$emit('input', $event)"
      :type="data.type ? data.type : 'text'"
      size="small"
      class="w-1/2"
      ref="input"
      :readonly="data.readonly"
    /> -->
    <FuseSelect
      v-if="!data.input && !data.multiple"
      class="w-1/2"
      :options="data.options"
      :value="value"
      @input="$emit('input', $event)"
      :disable="data.readonly"
    />
  </div>
</template>

<script setup>
import { ref, watch } from 'vue';
import { useElementBounding, useFocus } from '@vueuse/core';
import vSelect from 'vue-select';
import FuseSelect from '@/components/custom-ui/FuseSelect.vue';
defineProps({ data: {}, value: {} });

const isShowing = ref(false);
const input = ref();

const { focused } = useFocus(input);
watch(isShowing, () => {
  if (isShowing.value) {
    setTimeout(() => {
      focused.value = true;
    }, 10);
  } else {
    focused.value = false;
  }
});
</script>

<style>
.industry .q-field__inner {
  padding: 0;
}

.industry .q-field__native.row.items-center {
  gap: 4px;
}
.industry .q-field__control.relative-position.row.no-wrap {
  /* padding-top: 4px;
  padding-bottom: 4px; */
  padding: 4px 8px;
}
</style>
